import React, { SVGProps } from 'react';
type SVGRProps = {
  titleId?: string;
};
const SvgIcoSettingsCog = ({ titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 33 33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    aria-labelledby={titleId}
    {...props}
  >
    <title id={titleId}>SettingsCog</title>
    <path
      d="M16.008 20.879a3.892 3.892 0 1 0 0-7.785 3.892 3.892 0 0 0 0 7.785Z"
      stroke="currentColor"
      strokeWidth={1.999}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      clipRule="evenodd"
      d="M18.378 5.793a1.714 1.714 0 0 0-1.68-1.378h-1.38c-.817 0-1.52.577-1.681 1.378l-.236 1.18a1.714 1.714 0 0 1-2.631 1.089l-1.001-.667a1.714 1.714 0 0 0-2.163.214l-.976.976a1.714 1.714 0 0 0-.214 2.163l.667 1a1.714 1.714 0 0 1-1.09 2.632l-1.179.236a1.714 1.714 0 0 0-1.378 1.68v1.38c0 .818.577 1.521 1.378 1.681l1.18.236a1.714 1.714 0 0 1 1.09 2.631l-.668 1.001a1.714 1.714 0 0 0 .214 2.163l.976.976a1.714 1.714 0 0 0 2.163.214l1-.667A1.714 1.714 0 0 1 13.402 27l.236 1.18c.16.8.864 1.377 1.68 1.377h1.381c.817 0 1.52-.577 1.68-1.378l.236-1.18a1.714 1.714 0 0 1 2.632-1.09l1 .668c.68.453 1.585.363 2.163-.214l.976-.976a1.714 1.714 0 0 0 .214-2.163l-.667-1a1.714 1.714 0 0 1 1.09-2.632l1.18-.236a1.714 1.714 0 0 0 1.377-1.68v-1.38c0-.818-.576-1.521-1.378-1.681l-1.18-.236a1.714 1.714 0 0 1-1.09-2.631l.668-1.001a1.714 1.714 0 0 0-.214-2.163l-.976-.976a1.714 1.714 0 0 0-2.162-.214l-1.001.667a1.714 1.714 0 0 1-2.632-1.09l-.236-1.18Z"
      stroke="currentColor"
      strokeWidth={1.999}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgIcoSettingsCog;
